import React from 'react';
import "./skills.scss"
import Exit from "../getBack/exit"
import Items from '../knowledgeItems/Items';
import Aos from 'aos';
import 'aos/dist/aos.css';

function Skills() {
    Aos.init()
    return (
        <>
        <div className="fullPage">
            <Exit/>
        <div data-aos ="fade-right" data-aos-duration="2050" className="heading">
                    SKILLS
                    <div className="subHeading">
                         SKILLS
                     </div>
                     <div  data-aos ="fade-right" data-aos-duration="2250" className="title">
                         I am having knowledge of
                </div>
                </div>
                <div className="triangular"></div>
                <div className="knowledgeItems">
                    <Items />
                </div>
        </div>
        </>
    );
}

export default Skills;